import * as React from 'react';
import { t } from '@reos/i18n';

/**
 * Drobne prezentacni atomy sdilene napric detailem zakazky (puvodne v
 * `zakazka-detail.tsx`). Vytazeno pri kroku M1, aby `ParcelPanel.tsx` mohl
 * pouzit stejny vzor badge/karty bez kruhoveho importu na routu.
 */

export function Card(props: {
  heading: string;
  hint?: string;
  testId?: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <section className="rh-card" {...(props.testId !== undefined ? { 'data-testid': props.testId } : {})}>
      <h2 style={{ margin: '0 0 4px', fontSize: 'var(--rh-size-section)' }}>{props.heading}</h2>
      {props.hint !== undefined && (
        <p style={{ margin: '0 0 12px', color: 'var(--rh-text-muted)', fontSize: 'var(--rh-size-meta)' }}>{props.hint}</p>
      )}
      {props.children}
    </section>
  );
}

export function Pill(props: { caption: string; bg: string; fg: string; title?: string | undefined }): React.JSX.Element {
  return (
    <span
      title={props.title}
      style={{ background: props.bg, color: props.fg, borderRadius: 999, padding: '1px 9px', fontSize: 'var(--rh-size-tag)', whiteSpace: 'nowrap' }}
    >
      {props.caption}
    </span>
  );
}

const STATUS_BADGE: Record<string, { caption: string; bg: string; fg: string }> = {
  VERIFIED: { caption: t('webAdmin.caseDetail.status.VERIFIED', { locale: 'cs' }), bg: 'var(--rh-success-bg)', fg: 'var(--rh-success)' },
  SUPPORTED: { caption: t('webAdmin.caseDetail.status.SUPPORTED', { locale: 'cs' }), bg: 'var(--rh-accent-soft)', fg: 'var(--rh-accent-ink)' },
  INFERRED: { caption: t('webAdmin.caseDetail.status.INFERRED', { locale: 'cs' }), bg: 'var(--rh-rule)', fg: 'var(--rh-text-muted)' },
  USER_INPUT: { caption: t('webAdmin.caseDetail.status.USER_INPUT', { locale: 'cs' }), bg: 'var(--rh-warning-bg)', fg: 'var(--rh-warning)' },
  OPEN: { caption: t('webAdmin.caseDetail.status.OPEN', { locale: 'cs' }), bg: 'var(--rh-danger-bg)', fg: 'var(--rh-danger)' },
  CONFLICT: { caption: t('webAdmin.caseDetail.status.CONFLICT', { locale: 'cs' }), bg: 'var(--rh-warning-bg)', fg: 'var(--rh-warning)' },
};

export function StatusBadge({ status }: { status: string }): React.JSX.Element {
  const b = STATUS_BADGE[status] ?? STATUS_BADGE['OPEN'];
  return <Pill caption={b?.caption ?? status} bg={b?.bg ?? 'var(--rh-rule)'} fg={b?.fg ?? 'var(--rh-text-muted)'} />;
}
